<div class="container container--wide">
  <div>
    <div edsSubGrid="layout-1" edsSubGridGap="md">
      <div edsSpacing="md">
        <eds-panel [hasBorders]="true" [hasPadding]="true" edsSpacing="md">
          <eds-section-header
            [level]="5"
            theme="dark"
            size="h5"
            [asOfLabel]="'products.as-of' | translate"
            [asOfDate]="ratingData?.asOfDate"
            edsSpacing="md"
          >
            {{ "products.overall-morningstar-rating" | translate }}
          </eds-section-header>
          <div edsSpacing="sm">
            <eds-rating
              [rating]="ratingData.morningStarRatingOverall"
              size="normal"
              [isHybrid]="ratingData.morningStarOverallHybrid"
              [title]="'products.morningstar-review' | translate"
            ></eds-rating>
            <eds-icon
              *ngIf="ratingData.morningStarOverallHybrid"
              type="info"
              size="small"
              tooltipPositionDefault="bottom"
              edsTooltip
              tooltipBehavior="fixed"
              [analyticsName]="
                'products.overall-morningstar-rating' | translate
              "
              tooltipType="large"
              [tooltipContent]="'products.morningstar-tooltip' | translate"
            ></eds-icon>
          </div>
          <p edsSpacing="sm">
            {{ "products.rating-category" | translate }}:&nbsp;{{
              ratingData?.morningStarCategory
            }}
          </p>
          <eds-image
            imgSrc="/assets/images/brand/Morningstar_Logo.png"
            altText="Morningstar"
          ></eds-image>
          <eds-proximal placement="MsModalOverall"></eds-proximal>
        </eds-panel>
        <ng-container [ngTemplateOutlet]="styleBlock"></ng-container>
      </div>
      <div>
        <ng-container [ngTemplateOutlet]="ratingsBlock"></ng-container>
      </div>
    </div>
    <eds-proximal placement="MsModalBottom"></eds-proximal>
  </div>
</div>
<ng-template #ratingsBlock>
  <eds-panel [hasBorders]="true" [hasPadding]="true">
    <eds-section-header
      [level]="5"
      theme="dark"
      size="h5"
      [asOfLabel]="'products.as-of' | translate"
      [asOfDate]="ratingData?.asOfDate"
      edsSpacing="md"
    >
      {{ "products.morningstar-historical-title" | translate }}
    </eds-section-header>
    <table
      class="table table--secondary"
      *ngIf="(isHandheld$ | async) !== true"
    >
      <thead class="table__thead">
        <tr class="table__tr">
          <th class="table__th text-align-right">
            <span class="small"
              >{{ "products.morningstar-years" | translate }}
            </span>
          </th>
          <th class="table__th text-align-right">
            <span class="small"
              >{{ "products.morningstar-ratings" | translate }}
            </span>
          </th>
          <th class="table__th text-align-right">
            <span class="small"
              >{{ "products.morningstar-fund-in-category" | translate }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="table__body">
        <tr class="table__tr">
          <td class="table__td text-align-right">3</td>
          <td class="table__td text-align-right">
            <eds-rating
              [rating]="ratingData?.morningStarRating3yr"
              size="small"
              [isHybrid]="ratingData.morningStar3yrHybrid"
              [title]="'products.morningstar-review' | translate"
            ></eds-rating>
            <eds-icon
              *ngIf="ratingData.morningStar3yrHybrid"
              type="info"
              size="small"
              tooltipPositionDefault="bottom"
              edsTooltip
              analyticsName="3"
              tooltipType="large"
              [tooltipContent]="'products.morningstar-tooltip' | translate"
            ></eds-icon>
          </td>
          <td class="table__td text-align-right">
            {{ ratingData?.monthEndNoOfFunds3yr }}
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td text-align-right">5</td>
          <td class="table__td text-align-right">
            <eds-rating
              [rating]="ratingData?.morningStarRating5yr"
              size="small"
              [isHybrid]="ratingData.morningStar5yrHybrid"
              [title]="'products.morningstar-review' | translate"
            ></eds-rating>
            <eds-icon
              *ngIf="ratingData.morningStar5yrHybrid"
              type="info"
              size="small"
              tooltipPositionDefault="bottom"
              edsTooltip
              analyticsName="5"
              tooltipType="large"
              [tooltipContent]="'products.morningstar-tooltip' | translate"
            ></eds-icon>
          </td>
          <td class="table__td text-align-right">
            {{ ratingData?.monthEndNoOfFunds5yr }}
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td text-align-right">10</td>
          <td class="table__td text-align-right">
            <eds-rating
              [rating]="ratingData?.morningStarRating10yr"
              size="small"
              [isHybrid]="ratingData.morningStar10yrHybrid"
              [title]="'products.morningstar-review' | translate"
            ></eds-rating>
            <eds-icon
              *ngIf="ratingData.morningStar10yrHybrid"
              type="info"
              size="small"
              tooltipPositionDefault="bottom"
              edsTooltip
              analyticsName="10"
              tooltipType="large"
              [tooltipContent]="'products.morningstar-tooltip' | translate"
            ></eds-icon>
          </td>
          <td class="table__td text-align-right">
            {{ ratingData?.monthEndNoOfFunds10yr }}
          </td>
        </tr>
      </tbody>
    </table>
    <ng-container *ngIf="(isHandheld$ | async) === true">
      <div class="cards-mobile" edsPadding edsPaddingAll="sm">
        <table
          class="table table--mobile"
          [class.table--even]="false"
          [class.table--last-child]="false"
          width="100%"
        >
          <tbody class="table__body">
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-years" | translate }}
              </td>
              <td class="small bold table__td text-align-right">3</td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-ratings" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                <eds-rating
                  [rating]="ratingData?.morningStarRating3yr"
                  size="small"
                  [isHybrid]="ratingData.morningStar3yrHybrid"
                  [title]="'products.morningstar-review' | translate"
                ></eds-rating>
                <eds-icon
                  *ngIf="ratingData.morningStar3yrHybrid"
                  type="info"
                  size="small"
                  tooltipPositionDefault="bottom"
                  edsTooltip
                  analyticsName="3"
                  tooltipType="large"
                  [tooltipContent]="'products.morningstar-tooltip' | translate"
                ></eds-icon>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-fund-in-category" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                {{ ratingData?.monthEndNoOfFunds3yr }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="cards-mobile cards-mobile__highlight"
        edsPadding
        edsPaddingAll="sm"
      >
        <table
          class="table table--mobile"
          [class.table--even]="true"
          [class.table--last-child]="false"
          width="100%"
        >
          <tbody class="table__body">
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-years" | translate }}
              </td>
              <td class="small bold table__td text-align-right">5</td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-ratings" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                <eds-rating
                  [rating]="ratingData?.morningStarRating5yr"
                  size="small"
                  [isHybrid]="ratingData.morningStar5yrHybrid"
                  [title]="'products.morningstar-review' | translate"
                ></eds-rating>
                <eds-icon
                  *ngIf="ratingData.morningStar5yrHybrid"
                  type="info"
                  size="small"
                  tooltipPositionDefault="bottom"
                  edsTooltip
                  analyticsName="5"
                  tooltipType="large"
                  [tooltipContent]="'products.morningstar-tooltip' | translate"
                ></eds-icon>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-fund-in-category" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                {{ ratingData?.monthEndNoOfFunds5yr }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cards-mobile" edsPadding edsPaddingAll="sm">
        <table
          class="table table--mobile"
          [class.table--even]="false"
          [class.table--last-child]="true"
          width="100%"
        >
          <tbody class="table__body">
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-years" | translate }}
              </td>
              <td class="small bold table__td text-align-right">10</td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-ratings" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                <eds-rating
                  [rating]="ratingData?.morningStarRating10yr"
                  size="small"
                  [isHybrid]="ratingData.morningStar10yrHybrid"
                  [title]="'products.morningstar-review' | translate"
                ></eds-rating>
                <eds-icon
                  *ngIf="ratingData.morningStar10yrHybrid"
                  type="info"
                  size="small"
                  tooltipPositionDefault="bottom"
                  edsTooltip
                  analyticsName="10"
                  tooltipType="large"
                  [tooltipContent]="'products.morningstar-tooltip' | translate"
                ></eds-icon>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="small table__td">
                {{ "products.morningstar-fund-in-category" | translate }}
              </td>
              <td class="small bold table__td text-align-right">
                {{ ratingData?.monthEndNoOfFunds10yr }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <eds-proximal placement="MsModalHistorical"></eds-proximal>
  </eds-panel>
</ng-template>

<ng-template #styleBlock>
  <eds-panel
    [hasBorders]="true"
    [hasPadding]="true"
    *ngIf="
      ratingData?.morningStarStyleboxType === 'Fixed Income' ||
      ratingData?.morningStarStyleboxType === 'Equity'
    "
  >
    <eds-section-header
      [level]="5"
      theme="dark"
      size="h5"
      [asOfLabel]="'products.as-of' | translate"
      [asOfDate]="ratingData?.morningStarPortfolioDate"
      edsSpacing="md"
    >
      {{ "products.morningstar-stylebox-title" | translate }}
    </eds-section-header>
    <div edsPadding edsPaddingTop="md">
      <span
        class="sr-only"
        *ngIf="ratingData?.morningStarStyleboxType === 'Equity'"
        >{{ "products.morningstar-stylebox-title-sr-equity" | translate }}
      </span>
      <span
        class="sr-only"
        *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'"
        >{{ "products.morningstar-stylebox-title-sr-fixed" | translate }}
      </span>
      <table
        class="table--morningstar-stylebox"
        tabindex="0"
        aria-hidden="true"
      >
        <caption class="table__legend">
          <span class="table__legend-list">
            <eds-icon class="table__current-icon"></eds-icon>
            {{ "products.morningstar-stylebox-current" | translate }}
          </span>
          <span class="table__legend-list">
            <eds-icon class="table__historical-icon"></eds-icon>
            {{ "products.morningstar-stylebox-historical" | translate }}
          </span>
        </caption>
        <tbody>
          <!-- 1st row start -->
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Equity'">
            <td
              class="table__td"
              *ngFor="let firstRow of styleboxArray; index as i"
              [class.table__historical]="
                ratingData?.morningStarStyleboxHist?.match((i + 1).toString())
              "
            >
              <eds-icon
                *ngIf="ratingData?.morningStarEqStylebox === (i + 1).toString()"
                class="table__current-icon"
              ></eds-icon>
            </td>

            <th class="table__th--vertical table__th--sub-heading">
              {{ "products.morningstar-stylebox-large" | translate }}
            </th>
            <th rowspan="3" class="table__th--vertical table__th--heading">
              {{ "products.morningstar-stylebox-size" | translate }}
            </th>
          </tr>
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'">
            <td
              class="table__td"
              *ngFor="let firstRow of styleboxArray; index as i"
              [class.table__historical]="
                ratingData?.morningStarStyleboxHist?.match((i + 1).toString())
              "
            >
              <eds-icon
                *ngIf="ratingData?.morningStarFiStylebox === (i + 1).toString()"
                class="table__current-icon"
              ></eds-icon>
            </td>
            <th class="table__th--vertical table__th--sub-heading">
              {{ "products.morningstar-stylebox-high" | translate }}
            </th>
            <th rowspan="3" class="table__th--vertical table__th--heading">
              {{ "products.morningstar-stylebox-quality" | translate }}
            </th>
          </tr>
          <!-- 1st row end -->

          <!-- 2nd row start -->
          <tr>
            <td
              class="table__td"
              *ngFor="let secondRow of styleboxArray; index as i"
              [class.table__historical]="
                ratingData?.morningStarStyleboxHist?.match((i + 4).toString())
              "
            >
              <ng-container
                *ngIf="ratingData?.morningStarStyleboxType === 'Equity'"
              >
                <eds-icon
                  *ngIf="
                    ratingData?.morningStarEqStylebox === (i + 4).toString()
                  "
                  class="table__current-icon"
                ></eds-icon>
              </ng-container>
              <ng-container
                *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'"
              >
                <eds-icon
                  *ngIf="
                    ratingData?.morningStarFiStylebox === (i + 4).toString()
                  "
                  class="table__current-icon"
                ></eds-icon>
              </ng-container>
            </td>
            <th class="table__th--vertical table__th--sub-heading">
              {{ "products.morningstar-stylebox-medium" | translate }}
            </th>
          </tr>
          <!-- 2nd row end -->
          <!-- 3rd row start -->
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Equity'">
            <td
              class="table__td"
              *ngFor="let thirdRow of styleboxArray; index as i"
              [class.table__historical]="
                ratingData?.morningStarStyleboxHist?.match((i + 7).toString())
              "
            >
              <eds-icon
                *ngIf="ratingData?.morningStarEqStylebox === (i + 7).toString()"
                class="table__current-icon"
              ></eds-icon>
            </td>
            <th class="table__th--vertical table__th--sub-heading">
              {{ "products.morningstar-stylebox-small" | translate }}
            </th>
          </tr>
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'">
            <td
              class="table__td"
              *ngFor="let thirdRow of styleboxArray; index as i"
              [class.table__historical]="
                ratingData?.morningStarStyleboxHist?.match((i + 7).toString())
              "
            >
              <eds-icon
                *ngIf="ratingData?.morningStarFiStylebox === (i + 7).toString()"
                class="table__current-icon"
              ></eds-icon>
            </td>
            <th class="table__th--vertical table__th--sub-heading">
              {{ "products.morningstar-stylebox-low" | translate }}
            </th>
          </tr>
          <!-- 3rd row end -->
          <!-- horizontal heading start -->
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Equity'">
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-value" | translate }}
            </th>
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-blend" | translate }}
            </th>
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-growth" | translate }}
            </th>
            <td colspan="2"></td>
          </tr>
          <tr *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'">
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-ltd" | translate }}
            </th>
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-mod" | translate }}
            </th>
            <th class="table__th--horizontal table__th--sub-heading">
              {{ "products.morningstar-stylebox-ext" | translate }}
            </th>
            <td colspan="2"></td>
          </tr>
          <tr>
            <th colspan="3" class="table__th--horizontal table__th--heading">
              <ng-container
                *ngIf="ratingData?.morningStarStyleboxType === 'Equity'"
              >
                {{ "products.morningstar-stylebox-style" | translate }}
              </ng-container>
              <ng-container
                *ngIf="ratingData?.morningStarStyleboxType === 'Fixed Income'"
              >
                {{ "products.morningstar-stylebox-duration" | translate }}
              </ng-container>
            </th>
            <td colspan="2"></td>
          </tr>
          <!-- horizontal heading end -->
        </tbody>
      </table>
    </div>
    <eds-proximal placement="MsModalStyleBox"></eds-proximal>
  </eds-panel>
</ng-template>
